import { Flex, Text } from "@chakra-ui/layout";
import Logo from "./Logo";
import SidebarLink from "./SidebarLink";
import { BellIcon } from "@chakra-ui/icons";

const SidebarMobile = () => {
	return (
		<Flex justify="space-between" p="16px" backgroundColor="zinc.50">
			<Flex alignItems="center" gap="10px">
				<Logo />
				<Text
					fontWeight="700"
					fontSize="20px"
					lineHeight="24px"
					display="inline"
				>
					Supembouts
				</Text>
			</Flex>
			<Flex>
				<SidebarLink
					icon={<BellIcon lineHeight="21px" w="21px" h="21px" />}
					to="/notifications"
				></SidebarLink>
			</Flex>
		</Flex>
	);
};

export default SidebarMobile;
